import React from 'react'

import styles from './tableEmptyOverlay.scss'

export default class TableEmptyOverlay extends React.Component {
  render() {
    return (
      <div data-cy="empty-overlay" className={styles.container}>
        There are no rows in this table
      </div>
    )
  }
}
